import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import jwt_decode from 'jwt-decode';
import { Observable, catchError, throwError } from 'rxjs';
import { LogoutUserAction } from '../state/user/user.actions';
import { UserSelectors } from '../state/user/user.selectors';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.store.selectSnapshot(UserSelectors.token);
    if (token) {
      const expSec = (jwt_decode<any>(token)?.exp as number | undefined) ?? undefined; // exp in seconds
      const nowMs = Date.now();
      const expMs = expSec ? expSec * 1000 : undefined;

      if (!expMs || expMs > nowMs) {
        // Token present and not expired -> attach Authorization header
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        // Token expired -> force logout
        this.store.dispatch(new LogoutUserAction());
      }
    }
    return next.handle(request).pipe(
      // If the server indicates the session/cookie is invalid or expired,
      // force logout to clear client-side state as well.
      catchError(err => {
        const status = err?.status as number | undefined;
        if (status === 401 || status === 419) {
          this.store.dispatch(new LogoutUserAction());
        }
        return throwError(() => err);
      })
    );
  }
}
